/* =============================================================
   Kadotorena – Navigation & UI JavaScript
   ============================================================= */

(function () {
  'use strict';

  /* ---- Side Navigation ---- */
  function initSideNav() {
    var openBtns = document.querySelectorAll('[data-kado-nav-open]');
    var closeBtn = document.querySelector('[data-kado-nav-close]');
    var backdrop = document.querySelector('.kado-nav-backdrop');
    var nav = document.querySelector('.kado-sidenav');

    if (!nav) return;

    function openNav() {
      nav.classList.add('is-open');
      backdrop.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      nav.setAttribute('aria-hidden', 'false');
    }

    function closeNav() {
      nav.classList.remove('is-open');
      backdrop.classList.remove('is-active');
      document.body.style.overflow = '';
      nav.setAttribute('aria-hidden', 'true');
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openNav);
    });

    if (closeBtn) closeBtn.addEventListener('click', closeNav);
    if (backdrop) backdrop.addEventListener('click', closeNav);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeNav();
      }
    });
  }

  /* ---- Hero Carousel ---- */
  function initHeroCarousel() {
    var carousels = document.querySelectorAll('[data-kado-carousel]');

    carousels.forEach(function (carousel) {
      var slides = carousel.querySelector('[data-kado-slides]');
      var dots = carousel.querySelectorAll('[data-kado-dot]');
      var prevBtn = carousel.querySelector('[data-kado-prev]');
      var nextBtn = carousel.querySelector('[data-kado-next]');
      var count = slides ? slides.children.length : 0;

      if (count === 0) return;

      var current = 0;
      var autoplayTimer = null;
      var autoplayDelay = 5000;

      function goTo(index) {
        current = (index + count) % count;
        slides.style.transform = 'translateX(-' + current * 100 + '%)';
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
          dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      }

      function startAutoplay() {
        autoplayTimer = setInterval(function () {
          goTo(current + 1);
        }, autoplayDelay);
      }

      function stopAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          stopAutoplay();
          goTo(current - 1);
          startAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          stopAutoplay();
          goTo(current + 1);
          startAutoplay();
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          stopAutoplay();
          goTo(i);
          startAutoplay();
        });
      });

      /* Touch/swipe support — scoped to carousel track only, not live panel */
      var carouselWrap = carousel.querySelector('.kado-hero__carousel-wrap') || carousel;
      var touchStartX = 0;
      carouselWrap.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      carouselWrap.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          stopAutoplay();
          goTo(diff > 0 ? current + 1 : current - 1);
          startAutoplay();
        }
      }, { passive: true });

      /* Pause on hover — scoped to carousel track only */
      carouselWrap.addEventListener('mouseenter', stopAutoplay);
      carouselWrap.addEventListener('mouseleave', startAutoplay);

      goTo(0);
      startAutoplay();
    });
  }

  /* ---- Auction Countdown ---- */
  function initCountdowns() {
    var countdowns = document.querySelectorAll('[data-kado-countdown]');

    countdowns.forEach(function (el) {
      var endDateStr = el.getAttribute('data-kado-countdown');
      if (!endDateStr) return;

      var endDate = new Date(endDateStr).getTime();
      if (isNaN(endDate)) return;

      var hEl = el.querySelector('[data-countdown-h]');
      var mEl = el.querySelector('[data-countdown-m]');
      var sEl = el.querySelector('[data-countdown-s]');

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var now = Date.now();
        var diff = endDate - now;

        if (diff <= 0) {
          if (hEl) hEl.textContent = '00';
          if (mEl) mEl.textContent = '00';
          if (sEl) sEl.textContent = '00';
          return;
        }

        var totalSeconds = Math.floor(diff / 1000);
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(minutes);
        if (sEl) sEl.textContent = pad(seconds);

        setTimeout(tick, 1000);
      }

      tick();
    });
  }

  /* ---- Init on DOM ready ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initSideNav();
    initHeroCarousel();
    initCountdowns();
  }
})();
